import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { ApiCalls } from '../../../../api/api';
import { FrequentQuestion } from '../../../../api/generated/data-contracts';
import { GET_HELP_FAQ } from '../../../../constants/queryKeys';

export const useFaqs = (
    options?: Omit<UseQueryOptions<FrequentQuestion[], unknown, FrequentQuestion[], string[]>, 'initialData' | 'queryKey' | 'queryFn'> & {
        initialData?: () => undefined;
    },
) => {
    return {
        ...useQuery({
            queryKey: [GET_HELP_FAQ],
            queryFn: () => ApiCalls.frequentQuestions({}).then(res => res.data.toSorted((a, b) => (a.order < b.order ? -1 : 1))),
            ...(options || {}),
        }),
        queryKey: [GET_HELP_FAQ],
    };
};
